import ApiService from 'services/api.service';
import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { LoadingOverlay } from '@onsolve/onsolve-ui-components';
import { t } from '@lingui/macro';
import configurationService from '../services/config.service';
import { useAuth } from './AuthContext';
const initialState = {
    googleMapsAPIKey: '',
    mapboxAccessToken: '',
    bugSnagApiKey: '',
    googleAnalyticsKey: '',
    datadogRumApplicationId: '',
    datadogClientToken: '',
    datadogSite: '',
    walkmeApiKey: '',
};
const EnvironmentContext = createContext(initialState);
export const EnvironmentProvider = ({ children }) => {
    const [envVars, setEnvVars] = useState(initialState);
    const [isLoading, setIsLoading] = useState(true);
    const contextValue = useMemo(() => envVars, [envVars]);
    const apiService = new ApiService(configurationService.ControlCenterApiUrl);
    const { isAuthenticated, isAuthLoading } = useAuth();
    useEffect(() => {
        async function loadEnvironmentVars() {
            try {
                const data = (await apiService.get('/api/environment')) || {};
                if (Object.keys(data).length === 0) {
                    console.error('Failed to load environment variables');
                    setIsLoading(false);
                    return;
                }
                const environmentVariables = data;
                setEnvVars(environmentVariables);
                setIsLoading(false);
            }
            catch (err) {
                console.error('Error loading environment variables:', err);
                setIsLoading(false);
            }
        }
        // Wait for auth loading to complete
        if (isAuthLoading) {
            return;
        }
        // Only load environment vars if authenticated
        if (isAuthenticated) {
            loadEnvironmentVars();
        }
        else {
            setIsLoading(false);
        }
    }, [isAuthenticated, isAuthLoading]);
    if (isLoading || isAuthLoading) {
        return <LoadingOverlay description={t `Please stand by.`} overlay/>;
    }
    return <EnvironmentContext.Provider value={contextValue}>{children}</EnvironmentContext.Provider>;
};
export const useEnvironment = () => {
    const context = useContext(EnvironmentContext);
    if (!context) {
        throw new Error('useEnvironment must be used within an EnvironmentProvider');
    }
    return context;
};
export { EnvironmentContext };
